/**
 * Returns `true` when inside a node environment,
 * else `false`.
 *
 * When using this it will remove any node code from the browser bundle - for example:
 *
 * ```js
 * if (isNodeEnvironment()) {
 *   // This code will be removed from the browser bundle
 * }
 * ```
 */
export var isNodeEnvironment = function () {
    var _a;
    // https://nodejs.org/api/process.html#process_process_release
    return typeof process !== 'undefined' && ((_a = process === null || process === void 0 ? void 0 : process.release) === null || _a === void 0 ? void 0 : _a.name) === 'node';
};
//# sourceMappingURL=is-node.js.map